import BudgetPrice from '@/domains/BudgetPrices/BudgetPrice';
import RpcService from "@/core/services/Rpc/RpcService";
import type RpcResponse from "@/core/services/Rpc/RpcResponse";
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import RpcDataSort from "@/core/services/Rpc/RpcDataSort";

/**
 * DAO для работы с бюджетными ценами.
 * Все методы делают запросы к серверу через RPC.
 */
class BudgetPricesDAO {

  static async get(productId: number): Promise<RpcResponse> {
    return RpcService.makeRequest('budgetPrices.get', { productId });
  }

	/**
	 * Загружает список бюджетных цен.
	 * @param filters    — фильтры
   * @param pagination — пагинация датагрида
   * @param sort       — сортировка датагрида
	 */
	static async getList(
    filters: {
      productIds?: number | number[],
      code?:       string,
    },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort
  ): Promise<RpcResponse> {

    let productIds = undefined;
    if (filters?.productIds) {
      if (Array.isArray(filters.productIds)) {
        productIds = filters.productIds;
      }
      else {
        productIds = [filters.productIds];
      }
    }

    return RpcService.makeRequest(
      'budgetPrices.getList',
      {
        ...filters,
        productId: productIds
      },
      pagination,
      sort
    );
	}

  static async upsert(budgetPrice: BudgetPrice): Promise<RpcResponse> {
    return RpcService.makeRequest('budgetPrices.upsert', { budgetPrice });
  }

	/**
	 * Создаёт бюджетную цену
	 */
	static async add(budgetPrice: BudgetPrice): Promise<RpcResponse> {
    return RpcService.makeRequest('budgetPrices.add', { budgetPrice });
	}

	/**
	 * Обновляет бюджетную цену
	 */
	static async update(budgetPrice: BudgetPrice): Promise<RpcResponse> {
    return RpcService.makeRequest('budgetPrices.update', { budgetPrice });
	}

	/**
	 * Удаляет бюджетную цену по id
	 */
	static async delete(id: number): Promise<RpcResponse> {
    return RpcService.makeRequest('budgetPrices.delete', { id });
	}
}

export default BudgetPricesDAO;
